  <!-- <div class="d-flex col-lg-9 col-12 mx-auto contactGrid">
 
    <div class="col-lg-6">

    </div>
    <div class="col-lg-6 py-5 letHelp">

    <div class="my-auto p-5" data-aos="fade-left" data-aos-duration="2000">
      <h2 class="text-uppercase m-0 py-3 lineHeight">let's help you <br /> for your queries</h2>
      <p style="line-height: 32px">Share your queries. We are looking <br /> forward to your message.</p>
      <div class="d-flex justify-content-start py-4">
        <a href="/reach-us"  class="customBtn text-decoration-none px-5 text-uppercase" role="button"> Contact Us...</a>
      </div>
    </div>

    </div>
  </div> -->

    <div class="contactGrid">
  <div class="container">
    <div class="custom-container">
      <div class="row">
  <div class="d-lg-flex mx-auto">
    <!-- <div>
      <img class="img-fluid" src="../../assets/images/contact.png" alt="">
    </div> -->
    <div class="col-lg-6">
      <img class="img-fluid py-lg-5 my-5" data-aos="fade-right" data-aos-duration="2000" src="../../assets/images/letstalk.png" alt="">

    </div>
    <div class="col-lg-6 my-auto overflow-hidden">

    <div class="my-auto px-lg-5" data-aos="fade-left" data-aos-duration="2000">
      <h2 class="text-uppercase m-0 py-3 lineHeight text-white">let's help you for your queries</h2>
      <p style="line-height: 32px">Share your queries. We are looking forward to your message.</p>
      <div class="d-flex justify-content-start py-4">
        <a href="/reach-us"  class="customBtn text-decoration-none px-5 text-uppercase" role="button"> Contact Us...</a>
      </div>
    </div>

    </div>
  </div>

</div>

</div>
</div>
</div>